const { find } = require("lodash");
import getAppCustomEnv from "@/utilities/get-app-custom-env";

export function getAppFeatureProp(props, appFeaturePropName) {
  const prop = find(props, { name: appFeaturePropName });
  if (!prop) {
    console.warn(`App feature prop ${appFeaturePropName} missing`);
    // Default to empty object for seamless destructuring
    return {};
  }
  return prop;
}

export async function getAppBaseUrl() {
  const appCustomEnv = await getAppCustomEnv();
  return appCustomEnv.VUE_APP_PLATFORM_APP_URL;
}

module.export = {
  getAppFeatureProp,
  getAppBaseUrl,
};
